export const posts = [
  {
    id: "1",
    title: "图书馆四楼「占座纸」被集中清理，当晚校园墙直接吵翻了",
    school: "江城大学",
    category: "campus",
    excerpt:
      "四楼自习区一夜之间清出两百多张占座纸，有人拍手叫好，也有人因为考研资料被打包收走而在群里连发长文。",
    author: "柠檬不叫柠檬",
    authorRole: "大四备考中",
    likes: 4821,
    comments: 673,
    views: 58240,
    createdAt: "2026-09-09",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20university%20library%20study%20area%20with%20stacked%20books%20and%20sticky%20notes%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-01&orientation=landscape",
    tags: ["占座", "图书馆", "考研"],
    hot: 1,
    featured: true,
    body: [
      "事情发生在前天晚上十点左右。图书馆四楼的管理员推着小车走了一圈，把桌面上长期无人、只压着一张纸的位置全部清空，纸张和杂物统一装袋，第二天早上在服务台认领。",
      "我就在四楼复习，亲眼看着过程。大部分人其实没意见，因为真正天天来的同学早就被占座纸挤到走廊加座了。真正吵起来的是第二天早上，几个同学发现自己的专业课笔记被一起收走，情绪很激动，在校园墙上发了长文。",
      "到中午，四楼服务台前排了二十多人的认领队伍，秩序出乎意料地好。管理员只说了一句话：条例四年前就贴在门口了，这次是按条例执行。",
    ],
    quote: "我们不是反对学习，我们只是希望位置留给真正坐在那里的人。",
    points: [
      "图书馆《阅览座位管理办法》2019 版明确规定离开超过 60 分钟视为放弃使用",
      "四楼当晚共清理占座纸张及杂物 213 份，认领截止到本周日",
      "考研自习区已临时开放二楼研讨室 40 个加座，凭学生卡现场登记",
    ],
  },
  {
    id: "2",
    title: "舍友半夜打游戏外放，我们宿舍的决定让整层楼都来围观",
    school: "明湖理工",
    category: "dorm",
    excerpt:
      "忍了两个月之后，我们四个人开了一次正式的宿舍会议，还打印了一份《宿舍公约》，结果隔壁宿舍直接来抄作业。",
    author: "住在 5 栋 412",
    authorRole: "大二在读",
    likes: 3960,
    comments: 512,
    views: 41760,
    createdAt: "2026-09-08",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20cozy%20student%20dorm%20room%20at%20night%20with%20four%20desks%20and%20soft%20lamps%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-02&orientation=landscape",
    tags: ["宿舍", "宿舍公约", "舍友"],
    hot: 2,
    featured: true,
    body: [
      "先说结论：沟通真的有用，但沟通之前要先定规则。我们宿舍的矛盾其实很典型，有位舍友习惯凌晨一点外放打排位，语音、技能音效、队友喊麦一个不少。",
      "第二个星期我们试过委婉提醒，效果维持了三天。后来我们干脆开了正式会议，每人写三条最不能接受的宿舍行为，取交集做成了《412 宿舍公约》，一共九条，打印出来贴在门后。",
      "有意思的是当天晚上隔壁宿舍来敲门，问能不能发一份电子版。现在整层楼至少有六个宿舍贴了类似的公约，宿管阿姨看到了还说要在楼栋群里推广。",
    ],
    quote: "矛盾不可怕，可怕的是大家都指望别人先开口。",
    points: [
      "会议控制在 30 分钟内，每人发言不打断",
      "公约只约束公共行为，不干涉个人作息与私人物品",
      "每学期末复盘一次，条款可以增删",
    ],
  },
  {
    id: "3",
    title: "同班男生在表白墙连发 30 条，结果被本人一次性回复了",
    school: "云麓师范大学",
    category: "love",
    excerpt:
      "从第一天的一条手写照片，到第三十天的长篇独白，整栋教学楼都在等更新，最后等来的是当事人的一句话。",
    author: "吃瓜第一排",
    authorRole: "大三在读",
    likes: 6734,
    comments: 981,
    views: 96420,
    createdAt: "2026-09-07",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20campus%20confession%20wall%20with%20paper%20notes%20and%20hearts%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-03&orientation=landscape",
    tags: ["表白墙", "校园情感", "连载"],
    hot: 3,
    featured: true,
    body: [
      "表白墙的运营同学后来告诉我们，这位男生的投稿是每天固定晚上十点半发来的，雷打不动，连续三十天。内容从第一天的「她今天借了我一支笔」到第三十天的三千字长文，说是在图书馆认识的第 179 天。",
      "围观群众从最开始的调侃，慢慢变成了每天蹲更新。第九天开始有人在评论区画时间线，第十八天甚至有同学做了进度条图。",
      "第三十一天，当事女生在表白墙匿名回复了一段话，大意是感谢，但希望把注意力放回自己的事情上。帖子当天就被顶上热榜第一，评论区居然出奇地温和，很多人说这才是成年人的体面。",
    ],
    quote: "喜欢可以很热烈，但回应别人的方式决定了你是个什么样的人。",
    points: [
      "表白墙运营方随后发布公告，鼓励一次性真诚表达，不提倡连载刷屏",
      "校心理咨询中心顺势推送了一期「如何健康表达好感」的科普",
      "当事男生的第三十一条投稿只有四个字：收到，谢谢",
    ],
  },
  {
    id: "4",
    title: "期末周自习室座位地图流出，哪栋楼最卷一目了然",
    school: "星洲学院",
    category: "study",
    excerpt:
      "有同学用一周时间统计了全校 11 栋楼自习室的实时空座，做成了一张热力图，发出来当天就被转发到各个学院的群里。",
    author: "数据派阿哲",
    authorRole: "大四统计系",
    likes: 2814,
    comments: 356,
    views: 33980,
    createdAt: "2026-09-06",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20heatmap%20chart%20about%20campus%20study%20rooms%20with%20grid%20tables%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-04&orientation=landscape",
    tags: ["自习室", "期末周", "数据统计"],
    hot: 4,
    featured: false,
    body: [
      "统计方法其实很朴素：我每天在固定六个时间点绕全校 11 栋楼走一圈，记录每栋楼的空座比例，连续记了七天，取平均。",
      "结论有点反直觉，最卷的不是主楼，而是东区独立的旧图书馆，早上七点半空座率就只有 12%。最清闲的反而是新建的第三教学楼，因为离宿舍远，晚上八点空座率还有六成以上。",
      "地图发出去之后，第二周第三教学楼的空座率就掉到三成以下了。怎么说呢，我的数据救了自己，也害了自己。",
    ],
    quote: "信息差其实就是一种资源，公开之后它立刻就不值钱了。",
    points: [
      "早高峰（7:30-8:30）空座率最低的三栋楼：东区旧馆、主楼、五教",
      "晚高峰（19:00-21:00）空座率最高的三栋楼：三教、西区实验楼、学术交流中心",
      "建议跨楼搜索座位，通勤十分钟换来一整个安静下午是划算的",
    ],
  },
  {
    id: "5",
    title: "社团招新现场有人举牌「不加社团也能保研」，辅导员请他喝了茶",
    school: "岭南海洋大学",
    category: "club",
    excerpt:
      "招新季的百团大战历来热闹，今年最出圈的是一块手写纸板，两小时冲上校园墙热榜，也把自己送进了辅导员办公室。",
    author: "社团老油条",
    authorRole: "大四社团负责人",
    likes: 3250,
    comments: 428,
    views: 38210,
    createdAt: "2026-09-05",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20lively%20campus%20club%20fair%20with%20booths%20and%20banners%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-05&orientation=landscape",
    tags: ["社团招新", "百团大战", "校园热点"],
    hot: 5,
    featured: false,
    body: [
      "那天下午的广场上大概有七十多个摊位，气氛很热。一块写着「不加社团也能保研」的纸板就这么竖在中间，举牌的男生说他自己是大三的，只是想说句实话。",
      "从结果看，他的话在两小时内被拍了几百次，确实有点打击招新气氛，好几个摊位的人流肉眼可见地少了。晚上辅导员找他聊了四十分钟，主要是提醒公共场合表达要注意影响。",
      "作为搞了三年社团的人，我其实想说，这话一半对一半不对。加社团确实不直接带来保研，但策划一场活动的组织能力、跟几十个人协作的沟通能力，在复试里是真的会被问到。",
    ],
    quote: "功利地做每件事，最后会发现没有一件事值得做。",
    points: [
      "百团大战今年共有 76 个社团参展，报名总人次同比上升 9%",
      "校方重申招新宣传不得使用夸大承诺，违规社团将取消下一年展位",
      "建议新生按兴趣选 1-2 个社团，投入深度比广度重要",
    ],
  },
  {
    id: "6",
    title: "从校招陪跑到拿下三家中厂 offer，我的四个月时间线全公开",
    school: "白鹭财经大学",
    category: "career",
    excerpt:
      "不贩卖焦虑，只讲清楚每一步做了什么。三月开始准备，七月拿到第一个 offer，中间被拒了 27 次。",
    author: "秋招上岸的鱼",
    authorRole: "应届毕业生",
    likes: 5140,
    comments: 764,
    views: 72930,
    createdAt: "2026-09-04",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20career%20timeline%20with%20documents%20and%20rising%20bars%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-06&orientation=landscape",
    tags: ["校招", "实习", "简历"],
    hot: 6,
    featured: false,
    body: [
      "先说背景，我是双非财经院校，之前只有一段三个月的实习，说实话起点不算好。三月我开始整理简历，前两周基本都在改同一版，删掉了所有形容词，只留结果和数字。",
      "四到六月是密集投递期，我统计了一下，一共投了 96 家，绝大部分是石沉大海。真正给我面试机会的是 14 家，其中 6 家走到终面，最后拿到 3 个 offer。",
      "被拒 27 次这件事我写在这里，是想告诉后来的人，被拒是过程不是结论。我每次面试完会立刻记三行复盘：哪个问题答崩了、下次怎么答、这家公司真正想要什么人。到七月，同样的问题我基本不会崩第二次。",
    ],
    quote: "求职是概率游戏，你能控制的只有把自己这份样本变得更好。",
    points: [
      "简历每一条经历都写成「做了什么 + 量化结果」，删掉所有自我评价",
      "投递按 3:5:2 分配，三成冲、五成稳、二成保底，不要只盯头部",
      "面试当天晚上必须写复盘，三行就够，坚持下来手感完全不同",
    ],
  },
  {
    id: "7",
    title: "一食堂新窗口排队 40 分钟，值不值得？我连续蹲了三天",
    school: "江城大学",
    category: "food",
    excerpt:
      "新开的砂锅窗口第一天就排到了楼梯口，有人说汤底绝了，也有人吃完直摇头。我带着小本子去测了三天。",
    author: "干饭监察员",
    authorRole: "大二在读",
    likes: 2470,
    comments: 318,
    views: 29640,
    createdAt: "2026-09-03",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20steaming%20clay%20pot%20dish%20on%20a%20student%20canteen%20tray%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-07&orientation=landscape",
    tags: ["食堂", "测评", "排队"],
    hot: 7,
    featured: false,
    body: [
      "第一天 11:40 到，队伍从窗口排到楼梯口，实测 42 分钟拿到餐。砂锅的分量比想象中大，两个人分一份完全够。",
      "第二天我特意错峰，13:05 再去，只排了 6 分钟。同一份砂锅，味道没有任何差别，所以这 36 分钟完全是可以省下来的。",
      "第三天我换了口味做对比，结论是汤底确实在水准之上，但配菜偏咸，建议少盐。综合来看，错峰去吃非常值得，正点去排 40 分钟就一般了。",
    ],
    quote: "食堂永远不缺好吃的东西，缺的是愿意错峰的人。",
    points: [
      "最佳时段：13:00-13:30，平均排队时间 5-8 分钟",
      "人均消费 14 元左右，砂锅分量偏大，两人拼单更划算",
      "重口同学建议点单时备注少盐，出锅前加一勺免费辣椒油更香",
    ],
  },
  {
    id: "8",
    title: "保研名单公示后，学院群里的沉默比讨论更精彩",
    school: "南岭大学",
    category: "grad",
    excerpt:
      "公示那天下午，平时最活跃的年级群整整安静了三个小时，第一条发言出现时，所有人都在盯着看。",
    author: "路过的研究生",
    authorRole: "研一在读",
    likes: 4203,
    comments: 587,
    views: 51280,
    createdAt: "2026-09-02",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20campus%20notice%20board%20with%20a%20published%20list%20and%20quiet%20students%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-08&orientation=landscape",
    tags: ["保研", "公示", "升学"],
    hot: 8,
    featured: false,
    body: [
      "名单是下午三点贴出来的，群里 480 个人，从三点到六点一条消息都没有。这种沉默里其实藏着很多情绪，有人松了口气，有人还没缓过来。",
      "六点零七分，班长发了一句「恭喜上岸的同学，也请暂时没上的同学一起加油」，然后群里开始刷屏。大部分是真实的祝贺，也有几句明显带着情绪。",
      "作为过来人，我想说的是，保研只是众多路径里的一条。我当年也没保上，后来统考进了同校同专业，回头看只是路线不同，终点并没有差那么远。",
    ],
    quote: "公示名单只是把很多条路的其中一条画粗了一点而已。",
    points: [
      "学院同步开放了复议通道，对成绩核算有疑问可在三日内提交材料",
      "未获得推免资格的同学，统考报名将于下月开放，院系提供一次免费规划咨询",
      "历届数据显示，统考进入同专业的学生占比并不低，不必过早否定自己",
    ],
  },
  {
    id: "9",
    title: "校园跑代跑被查，体测中心的处理方式引发大讨论",
    school: "明湖理工",
    category: "campus",
    excerpt:
      "本学期系统识别出 300 余条异常跑步轨迹，处理结果公布后，评论区一半支持一半喊冤。",
    author: "跑道上的风",
    authorRole: "大三在读",
    likes: 3021,
    comments: 466,
    views: 36120,
    createdAt: "2026-09-01",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20running%20track%20with%20gps%20route%20lines%20and%20a%20phone%20app%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-09&orientation=landscape",
    tags: ["校园跑", "体测", "诚信"],
    hot: 9,
    featured: false,
    body: [
      "体测中心这次动真格了。系统把轨迹速度、GPS 漂移和刷卡时间做了交叉比对，最终识别出 300 多条明显异常的记录。",
      "处理方式是：首次发现取消当月次数并记一次提醒，二次发现本学期成绩作废，需要参加补测。已经有人在群里说自己是骑车被误判了。",
      "我个人的看法是，规则本身没问题，问题在于申诉流程太短。目前只有两天时间提交证据，对不常用运动软件的同学确实不太友好。",
    ],
    quote: "规则要严，但申诉的口子也要开得足够宽。",
    points: [
      "异常判定维度：配速、轨迹连续性、打卡间隔、设备重复度",
      "申诉通道开放两天，可通过体育部邮箱提交轨迹截图与说明",
      "补测时间安排在下月前两周的周末，需提前在教务系统预约",
    ],
  },
  {
    id: "10",
    title: "开学季快递站爆仓，我的六个包裹到底消失在哪一步",
    school: "星洲学院",
    category: "dorm",
    excerpt:
      "开学第一周，南区快递站堆到过道都是纸箱，取件码显示已到站，可货架上一件都找不到。",
    author: "等快递的第 4 天",
    authorRole: "大二在读",
    likes: 1980,
    comments: 254,
    views: 24310,
    createdAt: "2026-08-31",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20crowded%20parcel%20pickup%20station%20with%20stacked%20cardboard%20boxes%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-10&orientation=landscape",
    tags: ["快递", "开学季", "避坑"],
    hot: 10,
    featured: false,
    body: [
      "先说结论：包裹没丢，只是还没上架。开学第一周南区站日均到件量大约是平时的四倍，工作人员把「已到站」的扫描提前做了，但实际分拣还要排队。",
      "我蹲了两天的规律是，早上九点前和晚上八点后去，人少且新货刚上架的概率高。中午去基本是白跑，前面排二三十人。",
      "另外提醒一下，大件最好选驿站自提点而不是校内站，校内站的大件区已经堆到没有下脚的地方了。",
    ],
    quote: "爆仓的时候，耐心和错峰比催单有用得多。",
    points: [
      "最佳取件时段：09:00 前、20:00 后，平均等待 10 分钟以内",
      "大件建议改到校外驿站自提点，校内站大件区已饱和",
      "显示「已到站」但找不到时先别急，通常 24 小时内会上架",
    ],
  },
  {
    id: "11",
    title: "宿舍楼下流浪猫被食堂阿姨正式「收编」，学生众筹起了猫粮",
    school: "云麓师范大学",
    category: "dorm",
    excerpt:
      "三花猫「小锅铲」从蹭饭常客变成了有工牌的编制猫，起因只是阿姨一句「它比你们准时」。",
    author: "楼下喂猫的人",
    authorRole: "大二在读",
    likes: 5620,
    comments: 701,
    views: 68450,
    createdAt: "2026-08-30",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20friendly%20calico%20cat%20sitting%20near%20a%20dorm%20building%20entrance%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-11&orientation=landscape",
    tags: ["流浪猫", "校园温情", "众筹"],
    hot: 11,
    featured: true,
    body: [
      "小锅铲是我们楼下常驻的三花，每天中午十一点半准时出现在食堂后门。上个月食堂阿姨用纸板给它做了个小牌子挂在树上，写着「本窗口编外员工」。",
      "照片发到校园墙之后直接上了热榜。更让人没想到的是，隔壁烘焙社的同学认领了它的口粮，每周固定送两次；医学院的学长带它做了体检和驱虫。",
      "现在小锅铲有专属的小窝、饮水碗和一张贴着工牌的纸箱。阿姨说得很实在：它比很多同学都准时，这编制给得心安理得，当然，它不上班。",
    ],
    quote: "一个学校怎么对待流浪动物，大概能看出它的温度。",
    points: [
      "小锅铲已完成体检、驱虫与绝育，健康状况良好",
      "学生自发众筹的猫粮由烘焙社统一管理，每月公开一次收支",
      "请勿投喂人类剩饭，高盐高油对猫的肾脏负担很重",
    ],
  },
  {
    id: "12",
    title: "跨校联谊报名人数超出预期三倍，主办方连夜换了场地",
    school: "南岭大学",
    category: "club",
    excerpt:
      "原本只准备了 120 个名额，报名通道开放 48 小时涌进 400 多人，工作人员只好把场地从礼堂换到体育馆。",
    author: "联谊志愿者",
    authorRole: "大三在读",
    likes: 2740,
    comments: 342,
    views: 31870,
    createdAt: "2026-08-29",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20campus%20social%20gathering%20in%20a%20gym%20with%20students%20and%20balloons%2C%20warm%20coral%20amber%20and%20lime%20palette%2C%20minimal%20geometric%20shapes%2C%20clean%20cream%20background&width=800&height=500&seq=campus-post-12&orientation=landscape",
    tags: ["联谊", "社团活动", "跨校"],
    hot: 12,
    featured: false,
    body: [
      "这场联谊是四所学校联合办的，我们原本按 120 人准备场地和物料，报名通道开放 48 小时后后台数字停在了 427。",
      "当天晚上我们就开了紧急会，把场地从学术礼堂换到了体育馆，物料按 1.6 倍追加，志愿者从 18 人扩到 40 人。",
      "活动当天实际到场 380 多人，分组破冰的环节比预想的顺利。复盘下来最大的教训是，报名名额应该设置候补队列并提前做意愿确认，这次有一百多人报名后没来。",
    ],
    quote: "办活动最难的不是创意，是把报名的热情换算成真实的到场率。",
    points: [
      "本次活动实际到场率约 89%，未到场名额未做释放是主要失误",
      "下次将启用候补队列，报名后需在 24 小时内确认参加意愿",
      "场地与物料按 1.6 倍冗余准备，留出弹性空间",
    ],
  },
];